import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";
import EASSearchCard from "components/school/eas/eas-search-card";
import EASClosed from "components/school/eas/eas-closed";
import { Col, Row, Spin } from "antd";
import CSVLinkButton from "./CSVLinkButton";

const EASApplications: React.FC = () => {
  const { t } = useTranslation();
  const { isEasOpen } = useAppSelector(state => state.properties.closingData);
  const { loading } = useAppSelector(state => state.properties);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById("skip-main-wrap")?.focus();
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("helmet.easApplications.title")}</title>
        <meta name="description" content={t("helmet.easApplications.meta") || ""} />
      </Helmet>

      {isEasOpen ? (
        <>
          <Row>
            <Col md={{ span: 20 }} sm={{ flex: "100%" }}>
              <h1 className="display-mid-typo gap-section">{t("easApplications.title")}</h1>
            </Col>
            <Col md={{ span: 4 }} sm={{ flex: "100%" }}>
              <CSVLinkButton />
            </Col>
          </Row>
          <EASSearchCard desktop={true} />
        </>
      ) : loading ? (
        <Spin />
      ) : (
        <EASClosed />
      )}
    </>
  );
};

export default EASApplications;
